import { render } from "./footer.vue?vue&type=template&id=7554ed54"
const script = {}

import exportComponent from "/home/innovation/Documents/project/for small pos/akezaStore/clientnew/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__